import { Option } from '../components/common/types/DropdownItem.types';

const searchOptions = <T extends Option>(options: T[], searchText: string): T[] => {
  const result: T[] = [];
  const searchTextLower = searchText.toLowerCase().trim();
  const searchWords = searchTextLower.split(/\s+/).filter((word) => word.length > 0);

  const isNameMatching = (name: string): boolean => {
    if (searchWords.length === 0) return false;

    const nameLower = name.toLowerCase();

    if (nameLower.includes(searchTextLower)) {
      return true;
    }

    const nameWords = nameLower.split(/\s+/);
    return searchWords.every((searchWord) => nameWords.some((nameWord) => nameWord.includes(searchWord)));
  };

  options.forEach((option) => {
    const isCurrentMatch = isNameMatching(option.name);
    const matchingChildren = option.children ? searchOptions(option.children, searchText) : [];

    if (isCurrentMatch) {
      result.push(option);
    } else if (matchingChildren.length > 0) {
      result.push({
        ...option,
        children: matchingChildren,
      });
    }
  });

  return result;
};

export default searchOptions;
